import { render, staticRenderFns } from "./reports-modal-form.vue?vue&type=template&id=98474f36&scoped=true&"
import script from "./reports-modal-form.ts?vue&type=script&lang=ts&"
export * from "./reports-modal-form.ts?vue&type=script&lang=ts&"
import style0 from "./reports-modal-form.scss?vue&type=style&index=0&id=98474f36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98474f36",
  null
  
)

export default component.exports